// extracted by mini-css-extract-plugin
export default {"container":"contribution-reply_container__Kd43S","date":"contribution-reply_date__RVjZR","message":"contribution-reply_message__omwAW"};